export var hasNoIndex = function (description, events, eventsLoading) {
    return !description && !eventsLoading && events && !events.filter(function (e) { return e.eventDate.getTime() > Date.now(); }).length;
};
